import { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

import { Colors, Spacing } from "@paclife/plds.tokens";

import Typography from "common/Typography/Typography";
import OverflowMenu from "common/OverflowMenu/OverflowMenu";
import DeleteModal from "components/DeleteModal/DeleteModal";
import EditModal from "components/EditModal/EditModal";

import { PRIMARY_CEMAIL_TYPE, OTHER_CEMAIL_TYPE } from "constants/index";

const Wrapper = styled.div`
    display: flex;
`;

const Label = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: ${Spacing[8]};
    white-space: nowrap;
`;

const Text = styled(Typography)`
    display: block;
    color: ${({ color }) => color};
    &.label-text {
        margin-right: ${Spacing[4]};
    }
`;

const CEmail = ({ type, email }) => {
    const { t } = useTranslation("notification");
    const [editModal, setEditModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);

    const openEditModal = () => {
        setEditModal(type);
    };
    const openSwapModal = () => {
        setEditModal("swap");
    };
    const openDeleteModal = () => {
        setDeleteModal(true);
    };

    const closeEditModal = () => {
        setEditModal(false);
    };
    const closeDeleteModal = () => {
        setDeleteModal(false);
    };

    const menu =
        type === OTHER_CEMAIL_TYPE
            ? [
                {
                    icon: "edit",
                    color: Colors.neutral1000,
                    action: "Update",
                    onClick: openEditModal
                },
                {
                    icon: "refresh",
                    color: Colors.neutral1000,
                    action: "Make Primary",
                    onClick: openSwapModal
                },
                {
                    icon: "delete",
                    color: Colors.destructive,
                    action: "Delete",
                    onClick: openDeleteModal
                }
            ]
            : [];

    return (
        <div>
            <Wrapper>
                <OverflowMenu
                    icon={
                        type === PRIMARY_CEMAIL_TYPE
                            ? "edit"
                            : "overflowMenuVertical"
                    }
                    color={Colors.blue600}
                    onClick={openEditModal}
                    menu={menu}
                />
                <div>
                    <Label>
                        <Text
                            className="label-text"
                            variant="caption"
                            display="block"
                            color={Colors.textBodyLight}
                            bold
                        >
                            {type === PRIMARY_CEMAIL_TYPE
                                ? t("primary")
                                : t("other")}
                        </Text>
                    </Label>
                    <Text color={Colors.textBodyLight}>{email}</Text>
                </div>
            </Wrapper>
            {editModal && (
                <EditModal
                    type={editModal}
                    email={email}
                    closeModal={closeEditModal}
                />
            )}
            {deleteModal && (
                <DeleteModal
                    closeModal={closeDeleteModal}
                    factorType="email"
                    subType="additional"
                    defaultValue={email}
                />
            )}
        </div>
    );
};

export default CEmail;

CEmail.propTypes = {
    type: PropTypes.oneOf([PRIMARY_CEMAIL_TYPE, OTHER_CEMAIL_TYPE]).isRequired,
    email: PropTypes.string.isRequired
};
